export default __webpack_public_path__ + "fonts/open-sans-v16-latin-italic.woff";